import { render } from "./SystemSettingsView.vue?vue&type=template&id=4faacd86"
import script from "./SystemSettingsView.vue?vue&type=script&lang=js"
export * from "./SystemSettingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__